import React from "react";

import { useUnassignEmployeePortfoliosProperties } from "manager/hooks/api";
import { NOTIFICATIONS } from "shared/config/constants";
import { openNotification } from "shared/utils/ui";

import UnassignEmployeeFromPropertyModal from "./UnassignEmployeeFromPropertyModal";

interface UnassignEmployeeFromPortfolioModalContainerProps {
  values: {
    properties: (string | number)[];
    portfolios: (string | number)[];
  };
  employeeName: string;
  employeeId: string | number;
  propertyName: string;
}

const UnassignEmployeeFromPortfolioModalContainer = ({
  values,
  employeeName,
  employeeId,
  propertyName,
}: UnassignEmployeeFromPortfolioModalContainerProps) => {
  const {
    isUnassignEmployeePortfoliosPropertiesLoading,
    unassignEmployeePortfoliosProperties,
  } = useUnassignEmployeePortfoliosProperties({
    employeeId,
    values,
  });

  const onSubmit = () =>
    unassignEmployeePortfoliosProperties(null, {
      onSuccess: () =>
        openNotification(
          `${employeeName} has been successfully unassigned from ${propertyName} property`,
          NOTIFICATIONS.info
        ),
      onError: () =>
        openNotification(
          `Failed to unassign ${employeeName} from ${propertyName} property`,
          NOTIFICATIONS.error
        ),
    });

  return (
    <UnassignEmployeeFromPropertyModal
      employeeName={employeeName}
      propertyName={propertyName}
      onSubmit={onSubmit}
      submitting={isUnassignEmployeePortfoliosPropertiesLoading}
    />
  );
};

export default UnassignEmployeeFromPortfolioModalContainer;
